import React, { useEffect, useState } from "react";
import MaterialBox from "../../../../components/MaterialBox";
import Grid from "@mui/material/Grid2";
import MaterialTypography from "../../../../components/MaterialTypography";
import MaterialInput from "../../../../components/MaterialInput";
import {
  CardContent,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Switch,
} from "@mui/material";
import MaterialButton from "../../../../components/MaterialButton";
import { useNavigate } from "react-router-dom";
import MaterialSelect from "../../../../components/MasterSelect";
import { fetchData } from "../../../../services";

export const MotorCategoryForm = ({ onsubmit, editCategoryData }) => {

  const navigate = useNavigate();
  const [categoryData, setCategoryData] = useState({
    // category information
    categoryName: "",
    code: "",
    description: "",
    parentCategoryId: "",
    active: true,

    // category information status
    categoryNameStatus: "unchecked",
    codeStatus: "unchecked",
    descriptionStatus: "unchecked",
    parentCategoryIdStatus: "unchecked",
  });
  const [parentKeyDropOptions, setParentKeyDropOptions] = useState([]);

  useEffect(() => {
    if (editCategoryData) {
      setCategoryData(editCategoryData);
    }
  }, [editCategoryData]);

  useEffect(() => {
    const getParentKeyIdFromCategory = async () => {
      try {
        const response = await fetchData(
          `/reference/motor/key-value-category?dropdown=true&isActive=true`
        );
        if (response?.success) {
          setParentKeyDropOptions(
            response?.data?.items?.map((item) => ({
              value: item.id,
              label: item.categoryName,
            }))
          );
        }
      } catch (error) {
        console.error("Error fetching Category");
      }
    };
    getParentKeyIdFromCategory();
  }, []);

  const handleCategoryDataChange = (event, selectEvent) => {
    let categoryState = { ...categoryData };

    if (event?.target) {
      switch (event.target.name) {

      case "categoryName": { 
        const upperValue = event.target.value.toUpperCase();
        const regex = /^[A-Z0-9_]{1,50}$/; 
        if (regex.test(upperValue)) { 
          categoryState[event.target.name + "Status"] = "success"; 
        } else { 
          categoryState[event.target.name + "Status"] = upperValue === "" ? "unchecked" : "error"; } 
          categoryState[event.target.name] = upperValue; 
          break; 
      }

      case "code": {
        const upperValue = event.target.value.toUpperCase();
        const regex = /^[A-Z0-9_]{1,25}$/;

        categoryState.code = upperValue;
        categoryState.codeStatus =
          upperValue === ""
            ? "unchecked"
            : regex.test(upperValue)
            ? "success"
            : "error";

        break;
      }

      case "description": {
        const value = event.target.value;
        const regex = /^[A-Za-z0-9 ]{2,100}$/;

        categoryState.description = value;
        categoryState.descriptionStatus =
          value === ""
            ? "unchecked"
            : regex.test(value.trim())
            ? "success"
            : "error";

        break;
      }

      case "active": {
        categoryState.active = event.target.value;
        break;
      }

      default:
        break;
    }

    } else if (!event?.target && selectEvent) {
      switch (selectEvent.name) {
        case "parentCategoryId": {
          const alphaNLenghthRegex = new RegExp("^([\\s\\S]{1,70})$");
          categoryState[selectEvent.name] = event;
          if (alphaNLenghthRegex.test(event?.trim?.())) {
            categoryState[selectEvent.name + "Status"] = "success";
          } else {
            categoryState[selectEvent.name + "Status"] =
              event === "" ? "unchecked" : "error";
          }

          break;
        }
      }
    }
    setCategoryData(categoryState);
  };

  const checkAllFields = () => {
    let allowSubmit = false;
    if (categoryData.categoryNameStatus === "success") {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  const handleSubmit = () => {
    if (checkAllFields()) {
      onsubmit(categoryData);
    }
  };

  return (
    <div>
      <CardContent sx={{ minHeight: "65vh" }}>
        <MaterialBox>
          <Grid container spacing={1}>
            <Grid size={{ xs: 12, sm: 6 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Category Name*
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                name="categoryName"
                placeholder="eg. category name"
                value={categoryData.categoryName}
                onChange={handleCategoryDataChange}
                error={
                  categoryData.categoryNameStatus === "error" ? true : false
                }
                success={
                  categoryData.categoryNameStatus === "success" ? true : false
                }
              />              
              {categoryData.categoryNameStatus === "error" && (
                <FormControl error>
                  <FormHelperText>
                    Name should be maximum 50 characters long and can contain
                    only capital letters(A-Z), numbers (0-9) and underscrores(_)
                  </FormHelperText>
                </FormControl>
              )}
            </Grid>

            <Grid size={{ xs: 12, sm: 6 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Category Code*
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                name="code"
                placeholder="eg. category code"
                value={categoryData.code}
                onChange={handleCategoryDataChange}
                error={categoryData.codeStatus === "error" ? true : false}
                success={categoryData.codeStatus === "success" ? true : false}
              />
              {(categoryData.codeStatus === "unchecked"  || categoryData.codeStatus === "success" )&& (
                <FormControl>
                  <FormHelperText>
                    Code should be maximum 25 characters long and can contain
                    only capital letters(A-Z), numbers (0-9) and underscrores(_)
                  </FormHelperText>
                </FormControl>
              )}
              
              {categoryData.codeStatus === "error" && (
                <FormControl error>
                  <FormHelperText>
                    Code should be maximum 25 characters long and can contain
                    only capital letters(A-Z), numbers (0-9) and underscrores(_)
                  </FormHelperText>
                </FormControl>
              )}
            </Grid>

            <Grid size={{ xs: 12, sm: 6 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Description
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                name="description"
                placeholder="eg. category description"
                value={categoryData.description}
                onChange={handleCategoryDataChange}
                error={
                  categoryData.descriptionStatus === "error" ? true : false
                }
                success={
                  categoryData.descriptionStatus === "success" ? true : false
                }
              />
              {categoryData.descriptionStatus === "error" && (
                <FormControl error>
                  <FormHelperText>
                    Description should be maximum 100 characters long and can
                    contain only alphabets
                  </FormHelperText>
                </FormControl>
              )}
            </Grid>

            <Grid size={{ xs: 12, sm: 6 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Parent Key
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
                name="parentCategoryId"
                value={categoryData.parentCategoryId}
                options={parentKeyDropOptions}
                onChange={handleCategoryDataChange}
                error={
                  categoryData.parentCategoryIdStatus === "error" ? true : false
                }
                success={
                  categoryData.parentCategoryIdStatus === "success"
                    ? true
                    : false
                }
              />
            </Grid>

            <Grid size={{ xs: 12, sm: 2 }}>
              <MaterialBox>
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Active
                </MaterialTypography>
              </MaterialBox>
              <FormControlLabel
                control={
                  <Switch
                    name="active"
                    checked={categoryData.active}
                    onChange={(event) =>
                      handleCategoryDataChange({
                        target: {
                          name: "active",
                          value: event.target.checked,
                        },
                      })
                    }
                    color="primary"
                  />
                }
                label={
                  <MaterialTypography variant="caption" fontWeight="bold">
                    {categoryData?.active ? "Yes" : "No"}
                  </MaterialTypography>
                }
                sx={{ marginLeft: 0 }}
              />
            </Grid>
          </Grid>
        </MaterialBox>
      </CardContent>
      <MaterialBox
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <MaterialButton
          sx={{ m: 2 }}
          variant="outlined"
          color="dark"
          onClick={() => {
            navigate("/motor-master/motor-category");
          }}
        >
          Cancel
        </MaterialButton>
        <MaterialButton
          sx={{ m: 2 }}
          variant="gradient"
          color="dark"
          disabled={!checkAllFields()}
          onClick={handleSubmit}
        >
          Submit
        </MaterialButton>
      </MaterialBox>
    </div>
  );
};
